export enum StudyModelChartFields {
  occlusalTest = 'occlusalTest',
  malocclusionClass = 'malocclusionClass',
  overbiteValue = 'overbiteValue',
  overjetValue = 'overjetValue',
  mistakesAndCompensationForImpression = 'mistakesAndCompensationForImpression',
  mistakesAndCompensationForPlaster = 'mistakesAndCompensationForPlaster',
  drawing = 'drawing',
}

export enum MalocclusionClass {
  first = 'first',
  second = 'second',
  third = 'third',
}

export const MalocclusionClassLabel = {
  [MalocclusionClass.first]: 'Ⅰ',
  [MalocclusionClass.second]: 'Ⅱ',
  [MalocclusionClass.third]: 'Ⅲ',
};

export enum OcclusalTest {
  Normal = 'Normal',
  Malocclusion = 'Malocclusion',
  Overbite = 'Overbite',
  Crowding = 'Crowding',
  Overjet = 'Overjet',
  Crossbite = 'Crossbite',
  EdgeToEdgeBite = 'EdgeToEdgeBite',
  Openbit = 'Openbit',
}

export const OcclusalTestLabel = {
  [OcclusalTest.Normal]: 'Normal',
  [OcclusalTest.Malocclusion]: 'Malocclusion : class',
  [OcclusalTest.Overbite]: 'Overbite',
  [OcclusalTest.Crowding]: 'Crowding',
  [OcclusalTest.Overjet]: 'Overjet',
  [OcclusalTest.Crossbite]: 'Crossbite',
  [OcclusalTest.EdgeToEdgeBite]: 'EdgeToEdgeBite',
  [OcclusalTest.Openbit]: 'Openbit',
};

export const StudyModelChartFormDefaultValues = {
  [StudyModelChartFields.occlusalTest]: [],
  [StudyModelChartFields.malocclusionClass]: null,
  [StudyModelChartFields.overbiteValue]: '',
  [StudyModelChartFields.overjetValue]: '',
  [StudyModelChartFields.mistakesAndCompensationForImpression]: '',
  [StudyModelChartFields.mistakesAndCompensationForPlaster]: '',
  [StudyModelChartFields.drawing]: '',
};

export const AttachmentFilesDefaultValues = {
  0: null,
  1: null,
  2: null,
  3: null,
  4: null,
};
